import { FC } from "react";
import { Chip, Link, Stack, Typography } from "@mui/material";
import { VerificationStatus } from "../../utils/getStatus";
import { getLocaleStringdDate } from "../../../../utils/dateFormatt";
import { ICompanyVerificationStatusesConfig } from "../../network";
import { getCategoryColor, getCategoryLabel } from "../../utils/getCategory";
import { Link as RouterLink } from "react-router-dom";
import { VerificationStatusBadge } from "../VerificationStatusBadge";

export const ApplicantSubtitle: FC<{
  status: VerificationStatus;
  deletedAt: string | null;
  category?: string;
  appId?: string;
  appName?: string;
  createdAt?: string;
  statusesConfig: ICompanyVerificationStatusesConfig;
}> = ({
  status,
  deletedAt,
  category,
  appId,
  appName,
  createdAt,
  statusesConfig,
}) => {
  return (
    <>
      <Stack direction='row' alignItems='center' spacing={1}>
        <VerificationStatusBadge
          status={status}
          statusesConfig={statusesConfig}
          suffix={deletedAt ? `At ${getLocaleStringdDate(deletedAt)}` : null}
        />
        {category ? (
          <Chip
            label={getCategoryLabel(category)}
            size='small'
            sx={{
              backgroundColor: `${getCategoryColor(category)}1A`,
              color: getCategoryColor(category),
              fontWeight: 600,
            }}
          />
        ) : null}
        {appId && appName ? (
          <Chip
            label={
              <Link
                component={RouterLink}
                to={`/companies/app/${appId}?general`}
                underline='hover'
                color='inherit'
                sx={{ fontWeight: 600 }}
              >
                {appName}
              </Link>
            }
            size='small'
            variant='outlined'
          />
        ) : null}
        {createdAt ? (
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "12px",
              lineHeight: "16px",
              letterSpacing: "0.5px",
              color: "info.main",
            }}
          >
            {new Date(createdAt).toDateString()}
          </Typography>
        ) : null}
      </Stack>
    </>
  );
};
